import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const STATUS_CLS = {
  Available: "text-gold",
  "Service Category": "text-foreground/60",
  "Coming Soon": "text-gold/80",
};

export default function ShowroomCard({ item, index, testId }) {
  const isFleet = item.tag === "fleet";
  const isUpcoming = item.status === "Coming Soon";
  const quoteLink = `/quote?requirement=${encodeURIComponent(item.title)}`;
  return (
    <Reveal delay={0.05 * (index % 2)} className="h-full">
      <article
        className={`group flex h-full flex-col border bg-ink transition-colors duration-500 hover:bg-smoke ${
          isUpcoming ? "border-dashed border-gold/25" : "border-gold/15"
        }`}
        data-testid={testId}
      >
        <div className="relative overflow-hidden">
          <img
            src={item.image}
            alt={item.alt}
            className={`img-spotlight aspect-video w-full object-cover ${isUpcoming ? "opacity-70" : ""}`}
            style={{ objectPosition: item.imgPos || "center" }}
            loading="lazy"
          />
          <span
            className={`absolute left-4 top-4 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.22em] ${
              isFleet ? "bg-gold text-ink" : "border border-foreground/30 bg-ink/85 text-foreground/70"
            }`}
            data-testid={`${testId}-tag`}
          >
            {isFleet ? "Our Fleet" : "Representative Image"}
          </span>
          {isUpcoming && (
            <span
              className="absolute right-4 top-4 border border-gold/60 bg-ink/85 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.22em] text-gold"
              data-testid={`${testId}-status-chip`}
            >
              {item.status}
            </span>
          )}
        </div>
        <div className="flex flex-1 flex-col p-8">
          <div className="flex items-baseline justify-between gap-4">
            <h3 className="font-heading text-xl leading-snug text-foreground transition-colors duration-300 group-hover:text-gold-light sm:text-2xl">
              {item.title}
            </h3>
            <span className="font-heading text-sm text-gold/70">{String(index + 1).padStart(2, "0")}</span>
          </div>
          {item.status && (
            <p className={`mt-2 text-[10px] font-semibold uppercase tracking-[0.22em] ${STATUS_CLS[item.status] || "text-gold/80"}`} data-testid={`${testId}-status`}>
              {item.status}
            </p>
          )}
          <p className="mt-4 text-sm leading-[1.8] text-muted-foreground">{item.desc}</p>
          {item.applications?.length > 0 && (
            <div className="mt-5 flex-1" data-testid={`${testId}-applications`}>
              <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-gold/80">Applications</p>
              <ul className="mt-3 flex flex-wrap gap-1.5">
                {item.applications.map((a) => (
                  <li key={a} className="border border-foreground/15 px-2.5 py-1 text-[11px] leading-snug text-foreground/70">
                    {a}
                  </li>
                ))}
              </ul>
            </div>
          )}
          <Link
            to={quoteLink}
            data-testid={`${testId}-enquire`}
            className={`mt-8 inline-flex items-center gap-2 border-t pt-5 text-[11px] font-semibold uppercase tracking-[0.22em] transition-colors hover:text-gold-light ${
              isUpcoming ? "border-dashed border-gold/25 text-gold/80" : "border-gold/15 text-gold"
            }`}
          >
            {isUpcoming ? "Register Interest" : "Enquire"}
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </div>
      </article>
    </Reveal>
  );
}

export function FutureCategoryCard({ testId }) {
  return (
    <Reveal delay={0.1} className="h-full">
      <div
        className="flex h-full min-h-[280px] flex-col items-center justify-center border border-dashed border-gold/25 bg-ink/40 p-8 text-center"
        data-testid={testId}
      >
        <span className="font-heading text-4xl text-gold/60">+</span>
        <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.28em] text-gold">Future Category</p>
        <p className="mt-3 max-w-xs text-sm leading-relaxed text-muted-foreground">
          New vehicle categories are added here as our fleet ecosystem grows.
        </p>
      </div>
    </Reveal>
  );
}
